import React from 'react';
import './LegalPages.css';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-content">
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last updated: January 2026</p>
          
          <section>
            <h2>1. Introduction</h2>
            <p>
              Vishwa Deva Homestay ("we," "our," or "us") is committed to protecting your privacy. 
              This Privacy Policy explains how we collect, use, disclose, and safeguard your information 
              when you visit our website, make bookings, or use our services.
            </p>
            <p>
              This policy is compliant with the Information Technology Act, 2000, and the Information 
              Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or 
              Information) Rules, 2011 of India.
            </p>
          </section>

          <section>
            <h2>2. Information We Collect</h2>
            <h3>2.1 Personal Information</h3>
            <p>We may collect the following personal information:</p>
            <ul>
              <li>Name and contact details (phone number, email address)</li>
              <li>Booking information (check-in/check-out dates, number of guests)</li>
              <li>Payment information (processed securely through third-party payment gateways)</li>
              <li>Identification documents (as required by law)</li>
              <li>Communication preferences</li>
            </ul>

            <h3>2.2 Automatically Collected Information</h3>
            <p>When you visit our website, we may automatically collect:</p>
            <ul>
              <li>IP address and device information</li>
              <li>Browser type and version</li>
              <li>Pages visited and time spent</li>
              <li>Referring website information</li>
            </ul>
          </section>

          <section>
            <h2>3. How We Use Your Information</h2>
            <p>We use the collected information for:</p>
            <ul>
              <li>Processing and confirming your bookings</li>
              <li>Providing customer support and services</li>
              <li>Sending booking confirmations and updates</li>
              <li>Improving our services and website</li>
              <li>Complying with legal obligations</li>
              <li>Marketing communications (with your consent)</li>
            </ul>
          </section>

          <section>
            <h2>4. Information Sharing and Disclosure</h2>
            <p>We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:</p>
            <ul>
              <li>With your explicit consent</li>
              <li>To comply with legal obligations or court orders</li>
              <li>To protect our rights, property, or safety</li>
              <li>With trusted service providers who assist in our operations</li>
            </ul>
          </section>

          <section>
            <h2>5. Data Security</h2>
            <p>
              We implement appropriate technical and organizational measures to protect your personal 
              information against unauthorized access, alteration, disclosure, or destruction. 
              However, no method of transmission over the internet is 100% secure.
            </p>
          </section>

          <section>
            <h2>6. Your Rights</h2>
            <p>Under applicable Indian laws, you have the right to:</p>
            <ul>
              <li>Access your personal information</li>
              <li>Correct inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Withdraw consent for marketing communications</li>
              <li>Lodge a complaint with relevant authorities</li>
            </ul>
          </section>

          <section>
            <h2>7. Cookies and Tracking</h2>
            <p>
              Our website may use cookies and similar technologies to enhance your experience. 
              You can control cookie settings through your browser preferences.
            </p>
          </section>

          <section>
            <h2>8. Third-Party Links</h2>
            <p>
              Our website may contain links to third-party websites. We are not responsible for 
              the privacy practices of these external sites.
            </p>
          </section>

          <section>
            <h2>9. Children's Privacy</h2>
            <p>
              We do not knowingly collect personal information from children under 18 years of age. 
              If you believe we have collected such information, please contact us immediately.
            </p>
          </section>

          <section>
            <h2>10. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any 
              material changes by posting the new policy on our website.
            </p>
          </section>

          <section>
            <h2>11. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy or our data practices, 
              please contact us at:
            </p>
            <div className="contact-info">
              <p><strong>Vishwa Deva Homestay</strong></p>
              <p>Phone: +919415600200</p>
              <p>Email: info@vishwadeva.com</p>
              <p>Address: D53/106 CHHOTI GAIBI, Rathyatra - Mahmoorganj Rd, opposite BCG SCHOOL FOR DEAF AND DUMB, Varanasi, Uttar Pradesh 221010</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 